// extracted by mini-css-extract-plugin
export default {"container":"SectionSign_container__7rw5u","details":"SectionSign_details__D5Ikl","buttons":"SectionSign_buttons__I2SGw","info":"SectionSign_info__-wQPL"};